import { Component, ViewChild, OnInit, AfterContentChecked, OnDestroy } from '@angular/core';
import { Router } from "@angular/router";
import { Subject, EMPTY, Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged, switchMap } from 'rxjs/operators';

import { PaginationComponent } from '../shared/components/pagination/pagination.component';

import { RecentPaymentsService } from "./recent-payments.service";
import { SnackbarService } from "../shared/services/snackbar.service";
import { TooltipService } from "../shared/services/tooltip.service";
import { RestrictOutsideScrollService } from "../shared/services/restrict-outside-scroll.service";

import { config } from "../../../config/index";

@Component({
    template: require('./recent-payments.component.html'),
    styles: [require('./recent-payments.component.less')],
    providers: [RecentPaymentsService, SnackbarService, TooltipService],
    preserveWhitespaces: true
})

export class RecentPaymentsComponent implements OnInit, AfterContentChecked, OnDestroy {

    paginationItems: any;
    reqPageOffset: number = 0;
    reqItemsPerPage: number = 10;
    startCount: any;
    endCount: any;
    searchValue: string = '';
    master: any;
    selectedType: any;
    paymentTotalCount: any;
    recentPaymentListResponse: any = [];
    payments: any = [];
    loading: boolean = true;
    currency: any;
    clickedPaymentData: any = null;
    selectedLocation: any;
    selectedPaymentType: any;
    locationList: any = [];
    sortParams: any = ['patient_name', 'due_date', 'last_payment_date', 'days_past_due'];
    sortParamsConfig: any = [];
    sortParam: string;
    order: string;
    isTouchDevice: boolean;

    currentDateInTimeZone: any;
    minDate: any;
    maxDate: any;
    receivedDate: any;
    receivedDatePicker: any;
    dateError: boolean;
    sendOfflineEmail: boolean = true;

    limitInputSub$: Subject<string> = new Subject<string>();
    searchInputSub$: Subject<string> = new Subject<string>();
    additionalInputSub$: Subject<string> = new Subject<string>();
    inputSubscription: Subscription;
    apiSubscription: Subscription;
    searchSubscription: Subscription;
    apiSubscriptions: Subscription[] = [];
    recentPaymentsapiSubscription: Subscription;
    hideDatepicker: boolean;

    @ViewChild("paginationId", { static: false }) setPagination: PaginationComponent;
    @ViewChild('offlinePaymentConfirmation', { static: false }) offlinePaymentConfirmation: any;
    @ViewChild("datePicker", { static: false }) dateFieldRef: any;

    constructor(
        private _patientPaymentService: RecentPaymentsService,
        private _router: Router,
        private _mdlSnackbarService: SnackbarService,
        private _restrictOutsideScrollService: RestrictOutsideScrollService,
        private _tooltipService: TooltipService,
    ) {
    }

    // for sorting
    sort(param: any) {
        this.sortParam = param;
        if (this.sortParamsConfig[param].firstToggle) {
            this.sortParamsConfig[param].firstToggle = false;
        } else {
            this.sortParamsConfig[param].sortDescending = !this.sortParamsConfig[param].sortDescending;
        }
        for (let i = 0; i < this.sortParams.length; i++) {
            if (this.sortParams[i] !== param) {
                this.sortParamsConfig[this.sortParams[i]].firstToggle = true;
            }
        }
        this.sortParamsConfig[param].sortDescending ? this.order = 'des' : this.order = 'asc';
        this.getRecentPayments();
    }

    /**
    * Function to set items Per page value
    * @param  {any} limitValue
    * @param  {any} event
    */
    setLimit(limitValue: any, event: any) {
        if (limitValue !== null) {
            this.master = limitValue;
            this.setPagination.changedValue = true;
            this.setPagination.itemsPerPage = this.master;
            this.paginationItems = this.setPagination.emitterEvent();
            this.reqItemsPerPage = this.paginationItems.passedItems;
            this.reqPageOffset = this.paginationItems.reqOffset;
            this.getRecentPayments();
        }
    }

    /**
     * Function to set maximum items to be displayed in a page
     * @param  {any} selectedPageNumber
     */
    maxItemsPerPage(selectedPageNumber: any) {
        if (selectedPageNumber < this.paymentTotalCount) {
            this.selectedType = selectedPageNumber + 1;
            this.setLimit(this.selectedType, event)
        }
    }

    /**
     * Function to capture event emitted from pagination component
     * @param  {any} event
     */
    paginationComponentEvent(event: any) {
        this.reqItemsPerPage = event.itemsPerPage;
        this.reqPageOffset = event.offset;
        if (event.isClicked) {
            this.getRecentPayments();
        }
    }

    /**
     * Function to set minimum no of items to be displayed in a page
     * @param  {any} selectedPageNumber
     */
    minItemsPerPage(selectedPageNumber: any) {
        if (selectedPageNumber > 1) {
            this.selectedType = selectedPageNumber - 1;
            this.setLimit(this.selectedType, event)
        }
    }

    /* Search Function fro listing */
    searchEvent = () => {
        this.reqPageOffset = 0;
        this.getRecentPayments();
    }

    getRecentPayments = () => {
        this.loading = true;
        this.recentPaymentsapiSubscription?.unsubscribe();
        this.recentPaymentsapiSubscription = this._patientPaymentService.getRecentPayments(this.searchValue, this.reqItemsPerPage, this.reqPageOffset, this.selectedLocation,
            this.selectedPaymentType, this.sortParam, this.order)
            .subscribe((res: any) => {
                if (!res.data) {
                    this.recentPaymentListResponse = [];
                } else {
                    this.recentPaymentListResponse = res.data;
                }

                this.paymentTotalCount = res.count;
                if (this.reqPageOffset >= 0) {
                    if (this.recentPaymentListResponse.length !== 0) {
                        this.startCount = this.reqPageOffset + 1;
                        this.endCount = this.startCount + this.recentPaymentListResponse.length - 1;
                    } else {
                        this.startCount = 0;
                        this.endCount = 0;
                    }
                }
                this.loading = false;
            },
                error => {
                    this._mdlSnackbarService.showSnackbar('SOMETHING_WENT_WRONG', 'error');
                    this.loading = false;
                });
    }

    openReceivedOfflinePaymentConfirmation(data: any) {
        this.clickedPaymentData = data;
        this.minDate = new Date(this.clickedPaymentData.signed_at).toISOString();
        this.hideDatepicker = true;
        this.dateError = false;
        this.setReceivedDate(data.time_zone);
        this.sendOfflineEmail = true;
        setTimeout(() => {
            this.hideDatepicker = false;
        });
        this.offlinePaymentConfirmation.show();
    }

    setReceivedDate(timeZone: string) {
        // Get the current date and time in the target timezone
        this.currentDateInTimeZone = new Date().toLocaleString('en-US', { timeZone: timeZone });
        this.currentDateInTimeZone = this.currentDateInTimeZone.split(', ')[0];
        // convert to date string in required format
        this.currentDateInTimeZone = new Date(this.currentDateInTimeZone);

        const day = this.currentDateInTimeZone.getDate();
        const year = this.currentDateInTimeZone.getFullYear();
        const month = this.currentDateInTimeZone.getMonth() + 1;

        // set max date for datepicker in yyyy-mm-dd format.
        this.maxDate = year + "-" + this.updateDateKey(month) + "-" + this.updateDateKey(day);

        this.receivedDatePicker = this.currentDateInTimeZone;
        this.receivedDate = this.updateDateKey(month) + "/" + this.updateDateKey(day) + "/" + year;
    }

    updateDateKey(value: any) {
        if (value.toString().length === 1) {
            value = "0" + value;
        }
        return value;
    }

    validateDate() {
        this.dateError = false;
        if (!this.receivedDate || (this.receivedDate && this.receivedDate.toString().length !== 10)) {
            this.dateError = true;
            return;
        }
        const date = this.receivedDate.split("/");
        const month = date[0];
        const day = date[1];
        const year = date[2];
        if (month && year && day) {
            if (!this.isValidDate(year, month - 1, day)) {
                this.dateError = true;
                return;
            }
        }
    }

    // check if entered date is today or greater than signed date
    isValidDate(year: any, month: any, day: any) {
        const formattedDate = new Date(year, month, day);
        formattedDate.setHours(0, 0, 0, 0);
        const minDateForComparison = new Date(this.minDate);
        minDateForComparison.setHours(0, 0, 0, 0);
        const currentDateForComparison = this.currentDateInTimeZone;
        currentDateForComparison.setHours(0, 0, 0, 0);

        if (formattedDate.getFullYear() == year && formattedDate.getMonth() == month && formattedDate.getDate() == day
            && formattedDate <= currentDateForComparison && formattedDate >= minDateForComparison) {
            return true;
        } else {
            return false;
        }
    }

    /**
     * Function to open Date picker.
     */
    openDatePicker() {
        if (document.activeElement instanceof HTMLInputElement) {
            document.activeElement.blur();
        }
        setTimeout(this.dateFieldRef.instance.show, 150);
    }

    /**
     * Function to set values based on datepicker.
     */
    onDatePickerChange($event: any) {
        if (!$event) {
            return;
        }
        this.receivedDate = $event;
        this.validateDate();
        return;
    }

    formatDateToYYYMMDD(receivedDate: any) {
        const date = receivedDate.split("/");
        return date[2] + '-' + date[0] + '-' + date[1];
    }

    markAsReceivedOffline() {
        if (this.dateError) {
            this._mdlSnackbarService.showSnackbar('INVALID_DATE', 'error');
        } else {
            this.offlinePaymentConfirmation.close();
            this.loading = true;

            const reqData = {
                payment_date: this.formatDateToYYYMMDD(this.receivedDate),
                send_confirmation_mail: this.sendOfflineEmail,
            };

            if (this.clickedPaymentData && this.clickedPaymentData.payment_type === 'Monthly') {
                this.apiSubscriptions.push(this._patientPaymentService.receivedOffline(this.clickedPaymentData.instance_id, reqData)
                    .subscribe((res: any) => {
                        this._mdlSnackbarService.showSnackbar('PAYMENT_MARKED_AS_RECEIVED_OFFLINE', 'success');
                        this.getRecentPayments();
                    },
                        error => {
                            this._mdlSnackbarService.showSnackbar('SOMETHING_WENT_WRONG', 'error');
                            this.loading = false;
                        }));
            } else {
                this.apiSubscriptions.push(this._patientPaymentService.receivedOfflineDownPayment(this.clickedPaymentData.instance_id, reqData)
                    .subscribe((res: any) => {
                        this._mdlSnackbarService.showSnackbar('PAYMENT_MARKED_AS_RECEIVED_OFFLINE', 'success');
                        this.getRecentPayments();
                    },
                        error => {
                            this._mdlSnackbarService.showSnackbar('SOMETHING_WENT_WRONG', 'error');
                            this.loading = false;
                        }));
            }
        }
    }

    /*Location Fetching function*/
    getLocation = () => {
        this.apiSubscriptions.push(this._patientPaymentService.getLocation()
            .subscribe((res: any) => {
                this.locationList = res.data;
            },
                error => {
                    this._mdlSnackbarService.showSnackbar('SOMETHING_WENT_WRONG', 'error');
                    this.loading = false;
                }));
    }

    ngOnInit() {
        this.selectedType = 10;
        this.getLocation();
        this.currency = config.currency;
        this.getRecentPayments();
        for (let i = 0; i < this.sortParams.length; i++) {
            let newConfig = {
                sortDescending: true,
                firstToggle: true
            }
            this.sortParamsConfig[this.sortParams[i]] = newConfig;
        }
        this.inputSubscription = this.limitInputSub$.pipe(
            debounceTime(300),
            distinctUntilChanged(),
            switchMap(event => {
                this.setLimit(this.selectedType, event);
                return EMPTY;
            })
        ).subscribe();
        this.searchSubscription  = this.searchInputSub$.pipe(
            debounceTime(300),
            distinctUntilChanged(),
            switchMap(event => {
                this.searchEvent();
                return EMPTY;
            })
        ).subscribe();
    }

    ngAfterContentChecked() {
        this.isTouchDevice = ("ontouchstart" in document.documentElement);
	}

    ngOnDestroy() {
        this.offlinePaymentConfirmation.close();
        this.inputSubscription?.unsubscribe();
        this.apiSubscriptions.forEach((subscription: any) => {
            subscription?.unsubscribe();
        });
        this.searchSubscription?.unsubscribe();
        this.recentPaymentsapiSubscription?.unsubscribe();
        
    }
}
